<style lang="css" scope>
  
</style>
<template>
  <div class="i-comment-wrap">
      <template v-if="comList && comList.length">
        <transition-group name="flip-list" class="i-comment-list" tag="ul">
          <li v-for="comment in comList" :key="comment.cid">
            <router-link :to="{name:'comment'}">
              <figure class="m-user">
                <img :src="userMap[comment.suid].logo.thumb50" class="u-logo">&nbsp;
                <span class="inlineBlock">{{comment.content}}</span>
              </figure>
            </router-link>
          </li>
        </transition-group>
      </template>
  </div>
</template>

<script>
  import { commentList } from '../../../api/g/comment'
  import {forEach} from '../../../utils/base'
  import {mapActions, mapGetters} from 'vuex'
  export default {
    name: 'wz-comment-list',
    data() {
      return {
        list: [],
        //userMap: {}
      }
    },
    props: {
      objType: { type: [Number, String], default: 0 },
      objId: { type: [Number, String], default: 0 },
      start: { type: Number, default: 0 },
      pageNum: { type: Number, default: 20 },
      params: { type: Object, default: null },
      uptime: { type: Number, default: 0 },
    },
    computed: {
      ...mapGetters('comment',['talkList', 'userMap']),
      comList(){
        return this.talkList? this.talkList.reverse() : []
      },
      query() {
        const { objType, objId, start, pageNum, params, uptime } = this
        return {
          ...params,
          totalFlag: 1,
          objType,
          objId,
          start,
          pageNum,
          uptime
        }
      }
    },
    methods: {
      ...mapActions('comment', ['getCommentList']),
      user(uid) {
        return this.userMap[uid] || { uid: uid, nick: `xs_${uid}`, logoSrc: '' }
      },
      async fetch() {
        const { query } = this
        const R = await this.getCommentList(query)
        console.log(R)
        /* const { total, list, userMap } = await commentList(query)
        this.userMap = userMap || {}
        this.list = list || []
        // console.log(list)

        this.$emit('success', {
          query,
          total
        }) */
      }
    },
    watch: {
      query() {
        this.fetch()
      },
    },
    created() {
      this.fetch()
    },
  }
</script>
